import React from "react";
import { FieldValues, useController } from "react-hook-form";

import { useTeams } from "lib/hooks/api/teams/useTeams";
import { useAssertCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { CheckboxOption } from "./formUtils";
import { Select, SelectProps } from "./Inputs";

type FieldProps<T extends FieldValues> = Omit<SelectProps<T>, "options">;

type Option = {
  label: string;
  value: string;
  renderOption: React.ReactNode;
};

function TeamFilter<T extends FieldValues>(props: FieldProps<T>) {
  const { field } = useController(props);

  const currentUser = useAssertCurrentUser();
  const currentTeamId = currentUser.team.id;

  const { data: teams, isLoading: isLoadingTeam } = useTeams();

  const currentTeam = teams?.find((team) => team.id === currentTeamId);
  const otherTeams = teams?.filter((team) => team.id !== currentTeamId) ?? [];

  // Display the user's current team at the top of the list
  const allTeams = currentTeam ? [currentTeam, ...otherTeams] : [...otherTeams];

  const allTeamOptions: Option[] = allTeams.map((team) => ({
    value: team.id,
    label: team.name,
    renderOption: (
      <CheckboxOption
        id={team.id}
        checked={Array.isArray(field.value) && field.value.includes(team.id)}
        text={team.name}
      />
    ),
  }));

  return (
    <Select
      {...props}
      mode="multiple"
      placeholder="Select team"
      options={allTeamOptions}
      loading={isLoadingTeam}
      optionRender={({ data }) => data.renderOption}
      menuItemSelectedIcon={null}
    />
  );
}

export default TeamFilter;
